/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useMemo } from "react";
import {
  ContainerView,
  ContainerRow,
  ContainerV2,
  ContainerViewStake,
} from "../../../components/Container";
import { Form } from "antd";
import { useApp } from "../../../contexts";
import { InfoTooltipGradientIcon, InfoTooltipIcon } from "../../Home/styles";
import { Tooltip } from "antd";
import moment from "moment";
import {
  errorView,
  formatCurrency,
  getStakeEstimateGas,
  getDexWallet,
  getUserStakeInfo,
  stakeRequest,
  getStakeOtp,
  stakeRequestConfirm,
} from "../../../services/app";
import produce from "immer";
import { useNavigate } from "react-router-dom";
import { TitleWithBackWallet } from "../../../components/Layout";
import { WithdrawFormContainer } from "../styles";
import {
  Body,
  AuthFormInputSpan2,
  FormButton2,
  WalletConvertInfo,
  WalletConvertInfoItem,
  WalletConvertInfoItemTitle,
  WalletConvertInfoItemValue,
  FormButtonCancel3,
} from "./styles";

import FormInput from "../../../components/FormCustom2/Input";
import styled from "styled-components";
import { FormInputNumberRaw, FormItemRow } from "../../../components/Form";
import { AIAIcon } from "../../../components/Icons/AIAIcon";
import { error } from "../../../Notification";
import {
  RoundNumberOfDigitSGT,
  dateFormatNumber,
  formatNumber,
  formatPercentage,
} from "../../../utils/helper";
import { PolygonIcon } from "../../../components/Icons/PolygonIcon";
import { useWindowSize } from "../../../hook/useWindowSize";
import { SuccessGradient } from "../../../components/Icons/SuccessGradient";

const InputOtpWraper = styled.div`
  position: relative;
  flex: 1;
  & input {
    padding-right: 110px;
  }
`;

export default function StakeSGTComponent(props) {
  const { T, loading, setLoading, user } = useApp();
  const [form] = Form.useForm();
  const size = useWindowSize();
  const isMobile = size.width < 768;
  const navigate = useNavigate();

  const [otp, setOtp] = useState("");
  const [twoFa, setTwoFa] = useState("");
  const [sentOtp, setSentOtp] = useState(0);
  const [stepSuccess, setStepSuccess] = useState(false);
  const [formData, setFormData] = useState({});
  const [available, setAvailable] = useState(false);
  const [accountBalance, setAccountBalance] = useState({});
  const [gasData, setGasData] = useState({});
  const [stakeTx, setStakeTx] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState({});

  useEffect(() => {
    const timer = setInterval(() => {
      setSentOtp((prevState) => {
        if (prevState > 0) {
          return prevState - 1;
        }
        return prevState;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const loadDexData = async () => {
    let result = await getDexWallet();
    if (result.status === 200) {
      const address = result?.data?.data?.public_address;
      await loadFee(address);
    }
  };

  const loadData = async () => {
    const res = await getUserStakeInfo();
    const data = res?.data;
    setAccountBalance(data);
  };

  const loadFee = async (address) => {
    const res = await getStakeEstimateGas({
      network: "polygon",
      walletAddress: address,
    });
    setGasData(res?.data || {});
  };

  const onSubmitForm = async (values) => {
    setLoading(true);
    try {
      const result = await stakeRequest(values);
      setStakeTx(result?.data?.txId);
      scrollToTop();
    } catch (err) {
      error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const maxAmount = useMemo(() => {
    if (gasData && accountBalance) {
      return Math.min(
        gasData?.sgtBalance || 0,
        accountBalance?.availableBalance || 0
      );
    }
    return 0;
  }, [accountBalance, gasData]);

  const stakeOptions = useMemo(() => {
    const rates = gasData?.interestRates ?? [];
    return rates.map((item, index) => ({
      value: index,
      label: +item?.duration === 1 ? "{year} Year" : "{year} Years",
      year: +item?.duration,
      interestRate: +item?.rate,
    }));
  }, [gasData]);

  const energyInterestRate = useMemo(() => {
    const val = gasData?.energyConfig?.energyInterestRate;
    return val ? +val : 0;
  }, [gasData]);

  const rewardAmount = useMemo(() => {
    const val =
      +(formData?.amount ?? 0) * +(selectedDuration?.interestRate ?? 0);
    return val;
  }, [formData?.amount, selectedDuration?.interestRate]);

  const energyEarnAmount = useMemo(() => {
    const val = (+(rewardAmount ?? 0) * +(energyInterestRate ?? 0)) / 12;
    return val;
  }, [energyInterestRate, rewardAmount]);

  const rewardAmountDisplay = useMemo(() => {
    return rewardAmount ? `${formatNumber(rewardAmount, 2)} SGT` : "0 SGT";
  }, [rewardAmount]);

  const energyEarnAmountDisplay = useMemo(() => {
    return energyEarnAmount ? `${formatNumber(energyEarnAmount, 2)} e` : "0 e";
  }, [energyEarnAmount]);

  useEffect(() => {
    setIsDisabled(loading || !otp);
  }, [loading, otp]);

  const onUpdateData = () => {
    const values = form.getFieldsValue();
    setFormData(values);
    setAvailable(
      values.amount >= 1 && values.duration >= 0 && values.amount <= maxAmount
    );
  };
  const fetchAllData = async () => {
    try {
      setLoading(true);
      await Promise.all([loadData(), loadDexData()]);
    } catch (error) {
      setGasData({});
      setAccountBalance({});
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAllData();
  }, []);

  const onSentOtp = async () => {
    if (loading) return;
    setLoading(true);
    const result = await getStakeOtp({
      txId: stakeTx,
    });
    if (result?.data?.success) {
      setSentOtp(180);
    } else {
      setErrors(result?.data?.error?.validates || []);
    }
    setLoading(false);
  };

  const onSubmit = async () => {
    try {
      setLoading(true);
      const result = await stakeRequestConfirm({
        txId: stakeTx,
        emailCode: otp,
        twofaCode: user?.is_twofa ? twoFa : undefined,
      });
      if (result?.data?.success) {
        setStepSuccess(true);
        const start = new Date().getTime();
        const durationYear =
          stakeOptions.find((i, index) => index === formData.duration).year ||
          0;
        setStartDate(start);
        const endate = moment().add(durationYear, "years").unix() * 1000;
        setEndDate(endate);
        scrollToTop();
      } else {
        if (result?.data?.error?.message === "otp_invalid") {
          setErrors([
            {
              key: "verificationCode",
              value: T("Verification Code is not correct"),
            },
          ]);
        } else if (result?.data?.error?.message === "2fa_invalid") {
          setErrors([
            {
              key: "twofaCode",
              value: T("2FA Code invalid"),
            },
          ]);
        } else {
          error(T("Failed to create your request. Please try again later."));
        }
      }
    } catch (err) {
      if (err?.response?.data?.error?.message === "otp_invalid") {
        setErrors([
          {
            key: "verificationCode",
            value: T("Verification Code is not correct"),
          },
        ]);
      } else if (err?.response?.data?.error?.message === "2fa_invalid") {
        setErrors([
          {
            key: "twofaCode",
            value: T("2FA Code invalid"),
          },
        ]);
      } else {
        error(T("Failed to create your request. Please try again later."));
      }
    } finally {
      setLoading(false);
    }
  };

  const navigateToStakeList = () => {
    navigate(`/stake-for-option`);
  };

  const handleBackClick = () => {
    if (stakeTx && !stepSuccess) {
      setStakeTx(null);
    } else {
      navigateToStakeList();
    }
  };

  const renderEnterAmountScreen = () => {
    return (
      <>
        <div className="flex flex-col gap-1 mb-5 ">
          <div className="text-[15px] text-[#818181] leading-6">
            {T("Network")}
          </div>
          <div className="bg-[#F5F5F57A] lg:bg-[#F5F5F5] rounded-[10px] h-[50px] px-3 flex items-center justify-start gap-2 ">
            <PolygonIcon />
            <div className="text-black text-base">
              {T("Polygon Main Network")}
            </div>
          </div>
        </div>
        <div className="flex justify-start items-start lg:items-center gap-2 mb-5 lg:mb-3">
          <div className="note-icon w-[20px] h-[20px] mt-2 lg:mt-0">
            <img
              style={{ width: "100%", height: "100%" }}
              src={"/assets/images/alert.svg"}
              alt=""
              className="object-contain"
            />
          </div>
          <div
            className="flex-1 text-[13px]"
            dangerouslySetInnerHTML={{
              __html: T("withdraw.alert_stake_pol"),
            }}
          ></div>
        </div>
        <div className="flex flex-col gap-1 mb-5">
          <div className="text-[15px] text-[#818181] leading-6">
            {T("From Address")}
          </div>
          <div className="bg-[#F5F5F57A] lg:bg-[#F5F5F5] rounded-[10px] h-[50px] px-3 flex items-center justify-start gap-2">
            <AIAIcon />
            <div className="text-black text-base">
              {T("AI Avatar Web3 Wallet Address")}
            </div>
          </div>
        </div>
        <Form
          form={form}
          onFinish={() => {
            onSubmitForm(form.getFieldsValue());
          }}
          onValuesChange={() => onUpdateData()}
        >
          <FormItemRow
            {...errorView(errors, "amount")}
            className="no-after option-token-row"
            name={"amount"}
            label={T("Amount")}
            rules={[
              { required: true, message: T("Amount is required!") },
              {
                validator: (_, value) => {
                  if (value && value < 1) {
                    return Promise.reject(
                      new Error(T("Minimum stake = 1 SGT"))
                    );
                  }
                  if (value && value > maxAmount) {
                    return Promise.reject(new Error(T("Insufficient balance")));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <FormInputNumberRaw
              onChange={() => {
                setErrors(
                  produce((draft) => {
                    draft.splice(
                      draft.findIndex((item) => item.key === "amount"),
                      1
                    );
                  })
                );
              }}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              min={0}
              value={formData?.amount}
              onAll={() => {
                form.setFieldValue("amount", parseFloat(maxAmount || 0));
                setErrors(
                  produce((draft) => {
                    draft.splice(
                      draft.findIndex((item) => item.key === "amount"),
                      1
                    );
                  })
                );
                form.validateFields(["amount"]);
                onUpdateData();
              }}
              addonAfter={"SGT"}
              placeholder={T(`Please enter the amount`)}
              extra={
                <div className="relative">
                  <div className="absolute flex justify-end items-center right-0 text-[10px] text-[#818181] bottom-[-20px]">
                    {T("Max amount: {amount}").replace(
                      "{amount}",
                      `${maxAmount || 0} SGT`
                    )}
                    <Tooltip
                      trigger={isMobile ? "click" : "hover"}
                      onClick={(e) => e.stopPropagation()}
                      className="cursor-pointer mx-[5px]"
                      color={"#EAF2FF"}
                      overlayClassName={"note-tooltip-10"}
                      title={
                        <div>
                          <div>
                            {T(
                              "Your maximum stake is determined as the lower value between the following:"
                            )}
                          </div>
                          <ul className="list-disc pl-6">
                            <li>
                              {T(
                                "Web3 Balance (SGT currently in your web3 wallet): {amount} SGT"
                              ).replace(
                                "{amount}",
                                RoundNumberOfDigitSGT(gasData?.sgtBalance || 0)
                              )}
                            </li>
                            <li>
                              {T(
                                "Eligible Amount (SGT allowed to stake based on your exercised SOT limit): {amount} SGT"
                              ).replace(
                                "{amount}",
                                RoundNumberOfDigitSGT(
                                  accountBalance?.availableBalance || 0
                                )
                              )}
                            </li>
                          </ul>
                        </div>
                      }
                    >
                      <span>
                        <InfoTooltipIcon className={"w-[13px]"} />
                      </span>
                    </Tooltip>
                  </div>
                </div>
              }
            />
          </FormItemRow>
          <FormItemRow
            {...errorView(errors, "duration")}
            className="no-after option-token-row"
            name={"duration"}
            label={T("Duration")}
            rules={[{ required: true, message: T("Duration is required!") }]}
          >
            <div className="grid md:grid-cols-4 grid-cols-2 gap-3">
              {stakeOptions.map((item) => (
                <>
                  <div
                    className={`stake-duration ${
                      item.value === formData.duration ? "active" : ""
                    }`}
                    onClick={() => {
                      setSelectedDuration(item);
                      form.setFieldValue("duration", item.value);
                      onUpdateData();
                    }}
                  >
                    <div className="stake-duration-inner">
                      <span className="font-[600] text-[20px]">
                        {item.year}
                      </span>
                      <span className="font-[600] text-[10px] relative -top-[7px]">
                        {T(item.label).replace("{year}", "")}
                      </span>
                      <div className="font-[400] text-[12px]">
                        {`${T("Interest")} ${formatPercentage(
                          item.interestRate,
                          0
                        )}`}
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </FormItemRow>

          <div className="bg-[#0000001A] w-full mb-[5px] h-[1px]"></div>

          <ContainerRow style={{ marginTop: 12, marginBottom: 24 }}>
            <WalletConvertInfo style={{ flex: 1, paddingBottom: 6 }}>
              <WalletConvertInfoItem>
                <div className="relative">
                  <WalletConvertInfoItemTitle>
                    {T("Interest Amount")}
                  </WalletConvertInfoItemTitle>
                </div>
                <WalletConvertInfoItemValue>
                  {rewardAmountDisplay}
                </WalletConvertInfoItemValue>
              </WalletConvertInfoItem>

              <WalletConvertInfoItem>
                <div className="relative">
                  <WalletConvertInfoItemTitle>
                    {T("Est. Monthly Energy Earn")}
                    <Tooltip
                      trigger={isMobile ? "click" : "hover"}
                      onClick={(e) => e.stopPropagation()}
                      className="cursor-pointer mx-[5px]"
                      color={"#EAF2FF"}
                      overlayClassName={"note-tooltip-10"}
                      title={T(
                        "Energy earned is calculated annually based on staking reward amount and distributed to user every month based on amount of dates containing in month"
                      )}
                    >
                      <span>
                        <InfoTooltipIcon className={"w-[13px]"} />
                      </span>
                    </Tooltip>
                  </WalletConvertInfoItemTitle>
                </div>
                <WalletConvertInfoItemValue>
                  {energyEarnAmountDisplay}
                </WalletConvertInfoItemValue>
              </WalletConvertInfoItem>

              <div className="bg-[#0000001A] w-full my-[5px] h-[1px]"></div>

              <WalletConvertInfoItem>
                <div className="relative">
                  <WalletConvertInfoItemTitle>
                    {T("Estimated gas fee")}
                  </WalletConvertInfoItemTitle>
                  <div className="hidden lg:block absolute bottom-[-6px] text-[10px] text-[#818181]">
                    {T("Available Balance:")}{" "}
                    {`${RoundNumberOfDigitSGT(gasData?.nativeBalance, 8)} POL`}
                  </div>
                </div>

                <WalletConvertInfoItemValue>
                  {formData.amount >= 1 && formData.duration >= 0 ? (
                    <>
                      {formatCurrency(gasData?.gasFee)} {" POL"}
                    </>
                  ) : (
                    <>0 POL</>
                  )}
                </WalletConvertInfoItemValue>
              </WalletConvertInfoItem>
              <div className="flex lg:hidden justify-between items-center mt-[-6px]">
                <div className="text-[10px] text-[#818181]">
                  {T("Available Balance:")}
                </div>
                <div className="text-[10px] text-[#818181]">
                  {`${RoundNumberOfDigitSGT(gasData?.nativeBalance, 8)} POL`}
                </div>
              </div>
              {formData.amount >= 1 &&
              formData.duration >= 0 &&
              gasData?.gasFee > gasData?.nativeBalance ? (
                <>
                  <div className="text-red-500 text-[14px] italic mt-[4px]">
                    {T("Insufficient gas fee")}
                  </div>
                </>
              ) : (
                <></>
              )}
            </WalletConvertInfo>
          </ContainerRow>

          <div className="rounded-[10px] bg-[#F5AA191A] px-[10px] py-[14px] flex justify-start items-center gap-3 mb-8">
            <InfoTooltipGradientIcon className={"min-w-[15px]"} />
            <span>
              {T(
                "Please note that staking reward will be subject to future determination and announcement!"
              )}
            </span>
          </div>
          <div className="flex justify-center">
            <FormButton2
              disabled={!available}
              htmlType={"button"}
              onClick={() => {
                form.submit();
              }}
            >
              {T("Continue")}
            </FormButton2>
          </div>
        </Form>
      </>
    );
  };

  const renderEnterVerificationScreen = () => {
    return (
      <>
        <div className="lg:px-3 flex flex-col gap-4">
          <div className="row-item-sot">
            <div className="text-[#818181] font-semibold font-base ">
              {T("Network")}
            </div>
            <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
              <PolygonIcon />
              <div className="text-black text-base">
                {T("Polygon Main Network")}
              </div>
            </div>
          </div>
          <div className="row-item-sot">
            <div className="text-[#818181] font-semibold font-base ">
              {T("From Address")}
            </div>
            <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
              <AIAIcon />{" "}
              <span className="">{T("AI Avatar Web3 Wallet Address")}</span>
            </div>
          </div>

          <div className="row-item-sot">
            <div className="text-[#818181] font-semibold font-base ">
              {T("Stake Amount")}
            </div>
            <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex flex-wrap justify-start items-center gap-2">
              <img
                alt=""
                style={{ width: 24, height: 24 }}
                src={`/assets/images/otc/crypto/sgt.svg`}
              />
              <div className="text-black text-base">
                {`${formData.amount} SGT`}
              </div>
            </div>
          </div>

          <div className="row-item-sot">
            <div className="text-[#818181] font-semibold font-base ">
              {T("Duration")}
            </div>
            <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex flex-wrap justify-start items-center gap-[3px]">
              {T(selectedDuration?.label || "").replace(
                "{year}",
                selectedDuration?.year
              )}
              <span>{`(${T("Interest")} ${formatPercentage(
                selectedDuration.interestRate,
                0
              )})`}</span>
            </div>
          </div>

          <div className="row-item-sot">
            <div className="text-[#818181] font-semibold font-base ">
              {T("Interest Amount")}
            </div>
            <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex flex-wrap justify-start items-center gap-[3px]">
              <span>{rewardAmountDisplay}</span>
            </div>
          </div>

          <div className="row-item-sot">
            <div className="text-[#818181] font-semibold font-base ">
              {T("Est. Monthly Energy Earn")}
            </div>
            <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex flex-wrap justify-start items-center gap-[3px]">
              <span>{energyEarnAmountDisplay}</span>
            </div>
          </div>

          <div className="row-item-sot">
            <div className="text-[#818181] font-semibold font-base ">
              {T("Gas Fee")}
            </div>
            <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
              <PolygonIcon />
              <div className="text-black text-base">
                {`${gasData.gasFee} POL`}
              </div>
            </div>
          </div>
          <div className="row-item-sot stake-item">
            <div className="text-[#818181] font-semibold font-base flex justify-start items-center gap-[2px]">
              {T("Enter Email Verification Code")}
            </div>
            <div className="text-black font-normal text-base">
              <InputOtpWraper>
                <Form.Item
                  {...errorView(errors, "verificationCode")}
                  name={"otp"}
                  style={{
                    width: "100%",
                  }}
                >
                  <FormInput
                    value={otp}
                    className="input-sot2 no-border"
                    onChange={(event) => {
                      setOtp(event.target.value);
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex(
                              (item) => item.key === "verificationCode"
                            ),
                            1
                          );
                        })
                      );
                    }}
                    readOnly={sentOtp <= 0}
                    placeholder={
                      sentOtp <= 0
                        ? T("Click “Send Code”")
                        : T("Enter Email Verification Code")
                    }
                  />
                </Form.Item>
                <AuthFormInputSpan2
                  className={"send-code text-aia-red absolute"}
                  style={{ top: 14, right: 12 }}
                  onClick={() => {
                    if (sentOtp <= 0) {
                      onSentOtp().then();
                    }
                  }}
                >
                  {sentOtp > 0 ? `${sentOtp}s` : T("Send Code")}
                </AuthFormInputSpan2>
              </InputOtpWraper>
            </div>
          </div>
          {!!user?.is_twofa ? (
            <div className="row-item-sot stake-item mb-4">
              <div className="text-[#818181] font-semibold font-base flex justify-start items-center gap-[2px]">
                {T("Enter 2FA code2")}
              </div>
              <div className="text-black font-normal text-base">
                <Form.Item
                  {...errorView(errors, "twofaCode")}
                  name={"twofaCode"}
                  style={{
                    width: "100%",
                  }}
                >
                  <FormInput
                    value={otp}
                    maxLength="6"
                    className="input-sot"
                    onChange={(event) => {
                      setTwoFa(event.target.value);
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex((item) => item.key === "twofaCode"),
                            1
                          );
                        })
                      );
                    }}
                    placeholder={T("Enter 2FA code2")}
                  />
                </Form.Item>
              </div>
            </div>
          ) : null}
        </div>
        <div className="bg-[#0000001A] w-full mb-[30px] mt-[10px] h-[1px]"></div>
        <div className="flex justify-center items-center mt-4 gap-3 lg:mt-8">
          <FormButtonCancel3 onClick={navigateToStakeList}>
            <span>{T("Cancel")}</span>
          </FormButtonCancel3>
          <FormButton2
            disabled={isDisabled || loading}
            className={"lg:ml-3 ml-0 !w-[137px]"}
            onClick={() => onSubmit()}
          >
            {T("Confirm")}
          </FormButton2>
        </div>
      </>
    );
  };

  const renderSuccessScreen = () => {
    return (
      <>
        <ContainerViewStake>
          <WithdrawFormContainer>
            <div className="flex flex-col gap-[20px] lg:gap-[50px]">
              <div className="text-[20px] lg:text-[32px] leading-[36px] text-center text-[#000000] font-semibold">
                {T("Stake request confirmed")}
              </div>
              <div className="flex justify-center items-center">
                <SuccessGradient className={"w-[52px] lg:w-[80px]"} />
              </div>
              <div className="px-3 lg:px-24">
                <div className="grid grid-cols-12 lg:grid-cols-2 gap-3 mb-[10px]">
                  <div className="text-base col-span-6 lg:col-span-1 text-black capitalize">
                    {T("Stake Amount")}
                  </div>
                  <div className="text-base text-right col-span-6 lg:col-span-1">
                    {formData.amount} SGT
                  </div>
                </div>
                <div className="grid grid-cols-12 lg:grid-cols-2 gap-3 mb-[10px]">
                  <div className="text-base col-span-6 lg:col-span-1 text-black capitalize">
                    {T("Duration")}
                  </div>
                  <div className="text-base text-right col-span-6 lg:col-span-1">
                    {T(selectedDuration?.label || "").replace(
                      "{year}",
                      selectedDuration?.year
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-12 lg:grid-cols-2 gap-3 mb-[10px]">
                  <div className="text-base col-span-6 lg:col-span-1 text-black capitalize">
                    {T("Interest rate")}
                  </div>
                  <div className="text-base text-right col-span-6 lg:col-span-1">
                    {formatPercentage(selectedDuration.interestRate, 0)}
                  </div>
                </div>

                <div className="grid grid-cols-12 lg:grid-cols-2 gap-3 mb-[10px]">
                  <div className="text-base col-span-6 lg:col-span-1 text-black capitalize">
                    {T("Interest Amount")}
                  </div>
                  <div className="text-base text-right col-span-6 lg:col-span-1 text-aia-red">
                    {rewardAmountDisplay}
                  </div>
                </div>

                <div className="grid grid-cols-12 lg:grid-cols-2 gap-3 mb-[10px]">
                  <div className="text-base col-span-6 lg:col-span-1 text-black capitalize">
                    {T("Est. Monthly Energy Earn")}
                  </div>
                  <div className="text-base text-right col-span-6 lg:col-span-1">
                    {energyEarnAmountDisplay}
                  </div>
                </div>

                <div className="grid grid-cols-12 lg:grid-cols-2  gap-3 mb-[10px]">
                  <div className="text-base col-span-6 lg:col-span-1 text-black capitalize">
                    {T("Start date")}
                  </div>
                  <div className="text-base text-right col-span-6 lg:col-span-1">
                    {dateFormatNumber(startDate, "YYYY/MM/DD")}
                  </div>
                </div>
                <div className="grid grid-cols-12 lg:grid-cols-2 gap-3 mb-[10px]">
                  <div className="text-base col-span-6 lg:col-span-1 text-black capitalize">
                    {T("End date")}
                  </div>
                  <div className="text-base text-right col-span-6 lg:col-span-1">
                    {dateFormatNumber(endDate, "YYYY/MM/DD")}
                  </div>
                </div>
              </div>
              <div className="text-center font-medium lg:px-20">
                {T(
                  "Your stake request has been confirmed. Please check your mailbox for stake result!"
                )}
              </div>

              <div
                className="flex flex-col-reverse lg:flex-row justify-center 
                lg:flex-nowrap flex-wrap items-center gap-2 lg:px-20"
              >
                <FormButtonCancel3
                  onClick={() => navigate("/")}
                  className="!w-full lg:!w-auto"
                >
                  <span>{T("Back to Home")}</span>
                </FormButtonCancel3>
                <FormButton2
                  className={"lg:ml-3 ml-0 w-full lg:!w-auto"}
                  onClick={navigateToStakeList}
                >
                  {T("Create another stake")}
                </FormButton2>
              </div>
            </div>
          </WithdrawFormContainer>
        </ContainerViewStake>
      </>
    );
  };

  return (
    <ContainerV2>
      <ContainerView className="no-height">
        <TitleWithBackWallet
          className=" mt-3"
          title={T("Stake Request")}
          onClick={handleBackClick}
        />
      </ContainerView>
      {!stepSuccess ? (
        <ContainerViewStake>
          <WithdrawFormContainer>
            <Body className="form">
              {!stakeTx
                ? renderEnterAmountScreen()
                : renderEnterVerificationScreen()}
            </Body>
          </WithdrawFormContainer>
        </ContainerViewStake>
      ) : (
        renderSuccessScreen()
      )}
    </ContainerV2>
  );
}
